@if (hasInited) {
  <router-outlet></router-outlet>
} @else {
  <p role="status">Acesse este módulo pelo SGPREV para iniciar sua sessão.</p>
}
